import { render, staticRenderFns } from "./PlainDropdownPlayground.vue?vue&type=template&id=59b4d0b0&scoped=true&"
import script from "./PlainDropdownPlayground.vue?vue&type=script&lang=js&"
export * from "./PlainDropdownPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4d0b0",
  null
  
)

export default component.exports